<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {};
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath); // 动态跳转
        }
      },
      false
    );
  },

  metaInfo: {
    title: "Muchamo", // set a title
    meta: [
      {
        // set meta keyWords
        name: "keyWords",
        content:
          "rápido,dinero,cash,depósito,credit,préstamo,perú,crédito,efectivo,urgente",
      },
      {
        // set meta description
        name: "description",
        content:
          "Muchamo es una plataforma para préstamo seguro、préstamo en efectivo y préstamo de crédito personal sin hipoteca",
      },
    ],

    link: [
      {
        // set link
        rel: "asstes",
        href: "https://www.muchamo.com/Inicio",
      },
    ],
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
p,
ul {
  margin: 0;
}
a {
  text-decoration: none;
  cursor: pointer;
}
</style>
